export const dotColors = [
    '#0F9D58', // Verde
    '#DB4437', // Vermelho
    '#4285F4', // Azul
    '#7B1FA2', // Roxo
    '#F4B400', // Amarelo
    '#00BCD4', // Ciano
    '#E64A19', // Laranja Escuro
    '#3F51B5', // Índigo
];